'use strict';


module.exports = /*@ngInject*/ function($filter, FORMATS) {
	var angularDateFilter = $filter('date');
	return function(value) {
		return angularDateFilter(value, FORMATS.DATE);
	};
};
